<div class="table-nested-wrapper"
	 [class.block-loader]="loader.isLoading$ | async"
	 [class.is-open]="reportErrorColumn.isReportErrorLineListOpened">
	<loader-spinner [model]="loader"/>

	<table class="table table-nested table-sortable">
		<thead class="thead-light">
			<tr>
				<th class="col-id col-id-xl is-sortable"
					[ngClass]="getSortClasses(sortCols.LINE)"
					(click)="setSort(sortCols.LINE)"
					translate="DataList.Columns.Line">
				</th>
				<th class="col-error-msg is-sortable"
					[ngClass]="getSortClasses(sortCols.FACTOR_IDENTIFIER)"
					(click)="setSort(sortCols.FACTOR_IDENTIFIER)"
					translate="DataList.Columns.LineId">
				</th>
				<th class="col-name is-sortable"
					[ngClass]="getSortClasses(sortCols.COLUMN)"
					(click)="setSort(sortCols.COLUMN)">
					{{ columnName }}
				</th>
				@if (currentImport.type === ImportType.Accounting) {
					<th class="col-name is-sortable"
						[ngClass]="getSortClasses(sortCols.CLIENT_CODE)"
						(click)="setSort(sortCols.CLIENT_CODE)"
						translate="DataList.Columns.SuperDebtorId">
					</th>
				}
				<th class="col-btn-expand"></th>
			</tr>
		</thead>
		<tbody>
			@for (reportErrorLine of list.items; track reportErrorLine.lineNumber) {
				<tr>
					<td class="col-id col-id-xl"
						(click)="$event.stopPropagation()">
						<a>{{ reportErrorLine.lineNumber }}</a>
					</td>
					<td class="col-error-msg">
						{{ reportErrorLine.factorIdentifier }}
					</td>
					<td class="col-name">
						@if (reportErrorColumn.errorCode === errorCodes.DifferentAccountingDocumentTypeInFileVersusDatabase) {
							<span>{{ 'AccountingDocuments.Types.Full.' + reportErrorLine.extraMessage | translate }}</span>
						}
						@else { {{ reportErrorLine.cellValue}} }
					</td>
					@if (currentImport.type === ImportType.Accounting) {
						<td class="col-name">
							{{ reportErrorLine.clientCode }}
						</td>
					}
					<td class="col-btn-expand"></td>
				</tr>
			}
			@if (list.nbItems === 0) { <tr table-row-empty></tr> }
		</tbody>
	</table>
	<layout-list-paging [list]="list" [listHandler]="listHandler"/>
</div>
